/**
 * Utility function for broadcasting message events to other apps.
 */
export default function broadcast(type, data) {
  window.postMessage({ type, data }, window.location)

  
}
